import { useEffect, useState } from 'react';
import { formatAudioTime } from './state';

export default function AudioTimeline({ audioRef, track, verse, label, onSeek, disabled }) {
  const [currentTime, setCurrentTime] = useState(track.starts[verse - 1] || 0);
  useEffect(() => {
    const player = audioRef.current;
    const update = () => setCurrentTime((player.readyState ? player.currentTime : track.starts[verse - 1]));
    const events = ['timeupdate', 'loadedmetadata', 'seeked'];
    events.forEach(event => player.addEventListener(event, update));
    update();
    return () => events.forEach(event => player.removeEventListener(event, update));
  }, [audioRef, track, verse]);
  const time = Math.min(track.duration, Math.max(0, currentTime || 0));
  return <div className="audio-progress">
    <input type="range" min="0" max={track.duration} step="0.1" value={time} disabled={disabled}
      aria-label={label} aria-valuetext={`${formatAudioTime(time)} / ${formatAudioTime(track.duration)}`}
      style={{ '--progress': `${time / track.duration * 100}%` }}
      onChange={event => { const value = Number(event.target.value); setCurrentTime(value); onSeek(value); }}/>
    <div className="audio-times"><time>{formatAudioTime(time)}</time><time>{formatAudioTime(track.duration)}</time></div>
  </div>;
}
